import { Component, Fragment } from 'react';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faCheck, faChevronDown, faChevronRight, faFileAlt, faFlowerTulip, faFolder, faFolderOpen, faRightLeft, faTablePicnic, faTimes, faTree, faUsers } from '@fortawesome/pro-solid-svg-icons';
import GaugeProgressBar from '../../Utils/GaugeProgressBar';
import { Button, Card, Divider, Form, Grid, Input, Label, Select } from 'semantic-ui-react';
// Librairies
import { isMobileOnly } from 'react-device-detect';
import i18n from '../../../locales/i18n';
import { connect } from 'react-redux';
import tinycolor from 'tinycolor2';
import { setActiveOrganization } from '../../../actionCreators/usersActions';
import { setProjects } from '../../../actionCreators/projectsActions';
// Services
import OrganizationsService from '../../../services/OrganizationsService';
import ProjectsService from '../../../services/ProjectsService';
// Utils
import FormattersUtil from '../../../utils/FormattersUtil';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const $ = (str) => FormattersUtil.getNormalizedString(str);

class OrganizationProjects extends Component {
    state = {
        searchQuery: '',
        isLoading: false,
        isTransferring: false,
        selectedElements: [],
        selectedOrganization: null,
        baseProjects: [],
        collapsedFolderIds: [],
        treeSearchQuery: '',
    }

    render() {
        const { userSubscriptionConsumptions, organizations, isOnline, loginAsData, activeOrganization } = this.props;
        const { searchQuery, isTransferring, selectedElements, selectedOrganization, baseProjects, treeSearchQuery } = this.state;

        const organizationOptions = organizations
            .filter(organization => organization.id !== activeOrganization.id)
            .map(organization => ({ text: organization.label, value: organization.id }));

        const uscToRender = userSubscriptionConsumptions.filter(usc => !searchQuery?.trim() || (
            $(usc.project.label)?.includes($(searchQuery)) ||
            $(FormattersUtil.formatLastNameAndFirstName(usc.user.lastName, usc.user.firstName))?.includes($(searchQuery)) ||
            $(`${usc.nbTrees}`)?.includes(searchQuery) ||
            $(`${usc.nbGreenSpaces}`)?.includes(searchQuery) ||
            $(`${usc.nbFurnitures}`)?.includes(searchQuery)
        ));

        return (
            <>
                <Card className='org-card' style={{ width: '100%', margin: 0, borderRadius: 'var(--radius-lg)' }}>
                    <Card.Content>
                        <Card.Header className='home-card-head' style={{ display: 'flex', flexWrap: isMobileOnly ? 'wrap' : 'nowrap' }}>
                            <span className='home-card-head-icon'><FontAwesomeIcon icon={faFileAlt} /></span>
                            {i18n.t("Consommation des projets")}
                            <Form style={{ width: isMobileOnly ? '100%' : '250px', marginLeft: isMobileOnly ? 0 : 'auto', marginTop: isMobileOnly ? 'var(--spacing-sm)' : 0 }}>
                                <Form.Field control={Input} placeholder={i18n.t("Nom du projet, propriétaire, ...")} title={i18n.t("Nom du projet, propriétaire, ...")} value={searchQuery} icon='search' iconPosition='left' onChange={(_, { value }) => this.setState({ searchQuery: value })} />
                            </Form>
                        </Card.Header>
                        <Divider />
                        <div className='org-subsection'>
                            <Grid className='org-table' style={{ margin: 0 }}>
                                <Grid.Row stretched style={{ fontWeight: 'bold', paddingBottom: 0 }}>
                                    <Grid.Column computer={4} tablet={7} mobile={7}>{i18n.t("Projet")}</Grid.Column>
                                    <Grid.Column width={3} className='org-col-hide-tablet'>{i18n.t("Propriétaire")}</Grid.Column>
                                    <Grid.Column width={3}>
                                        <span className='org-text-desktop-only'>{i18n.t("Arbres")}</span>
                                        <span className='org-icon-tablet-only'><FontAwesomeIcon icon={faTree} /></span>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <span className='org-text-desktop-only'>{i18n.t("Espaces verts")}</span>
                                        <span className='org-icon-tablet-only'><FontAwesomeIcon icon={faFlowerTulip} /></span>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <span className='org-text-desktop-only'>{i18n.t("Mobiliers")}</span>
                                        <span className='org-icon-tablet-only'><FontAwesomeIcon icon={faTablePicnic} /></span>
                                    </Grid.Column>
                                </Grid.Row>
                                <Divider style={{ margin: '10px 0' }} />
                                <Grid.Row style={{ height: '350px', maxHeight: '350px', overflow: 'auto' }}>
                                    <Grid.Column>
                                        {uscToRender.length > 0 ?
                                            <Grid>
                                                {this.renderProjectsConsumptions(uscToRender)}
                                            </Grid>
                                            : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                                                <FontAwesomeIcon icon={faUsers} size='6x' />
                                                <p style={{ margin: '10px 0 0 0' }}>{i18n.t("Aucun projet trouvé.")}</p>
                                            </div>}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </Card.Content>
                </Card>
                <Card className='org-card' style={{ width: '100%', margin: 0, borderRadius: 'var(--radius-lg)' }}>
                    <Card.Content>
                        <Card.Header className='home-card-head' style={{ display: 'flex', flexWrap: isMobileOnly ? 'wrap' : 'nowrap', alignItems: 'center' }}>
                            <span className='home-card-head-icon'><FontAwesomeIcon icon={faFolder} /></span>
                            {i18n.t("Arborescence des projets")}
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '5px', marginLeft: isMobileOnly ? 0 : 'auto', marginTop: isMobileOnly ? 'var(--spacing-sm)' : 0, width: isMobileOnly ? '100%' : 'auto' }}>
                                {this.getAllFolderIds().length > 0 &&
                                    (this.isAllFoldersExpanded()
                                        ? <Button icon className='button--secondary' size='small' style={{ margin: 0 }} title={i18n.t("Tout replier")} onClick={this.collapseAllFolders}>
                                            <FontAwesomeIcon icon={faFolderOpen} />
                                        </Button>
                                        : <Button icon className='button--secondary' size='small' style={{ margin: 0 }} title={i18n.t("Tout déplier")} onClick={this.expandAllFolders}>
                                            <FontAwesomeIcon icon={faFolder} />
                                        </Button>)}
                                <Form style={{ width: isMobileOnly ? '100%' : '250px' }}>
                                    <Form.Field control={Input} placeholder={i18n.t("Nom du projet ou du dossier")} title={i18n.t("Nom du projet ou du dossier")} value={treeSearchQuery} icon='search' iconPosition='left' onChange={(_, { value }) => this.setState({ treeSearchQuery: value })} />
                                </Form>
                            </div>
                        </Card.Header>
                        <Divider />
                        {!isTransferring ?
                            organizations?.length > 1 &&
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                                <Button
                                    color='blue' disabled={!isOnline || loginAsData?.readOnly}
                                    onClick={() => this.setState(prevState => ({ isTransferring: !prevState.isTransferring, selectedElements: prevState.isTransferring ? [] : prevState.selectedElements }))}
                                    style={{ marginRight: 0 }}
                                >
                                    <FontAwesomeIcon icon={faRightLeft} style={{ marginRight: '10px' }} />{i18n.t("Transférer")}
                                </Button>
                            </div>
                            : <div style={{ display: 'flex', height: '36.5px', alignItems: 'center', marginBottom: '10px' }}>
                                <Select
                                    placeholder={i18n.t("Sélectionnez l'organisation cible...")} selectOnBlur={false} search={FormattersUtil.searchList} style={{ flexGrow: 1 }}
                                    options={organizationOptions} value={selectedOrganization} onChange={(_, { value }) => this.setState({ selectedOrganization: value })}
                                />
                                <Button color='grey' style={{ margin: '0 0 0 5px', padding: '11px' }} onClick={() => this.setState({ isTransferring: false, selectedElements: [], selectedOrganization: null })}>
                                    <FontAwesomeIcon icon={faTimes} style={{ marginRight: '10px' }} />{i18n.t("Annuler")}
                                </Button>
                                <Button color='green' style={{ margin: '0 0 0 5px', padding: '11px' }} disabled={!selectedElements?.length || !selectedOrganization} onClick={this.transferElements}>
                                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '10px' }} />{i18n.t("Valider")}
                                </Button>
                            </div>}
                        {isTransferring &&
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--spacing-sm)' }}>
                                <Label color='blue' style={{ width: 'fit-content' }}>
                                    {i18n.t("Cliquez pour sélectionner les éléments à transférer")}
                                </Label>
                            </div>}
                        <div className='org-subsection'>
                            <Grid className='org-table' style={{ margin: 0 }}>
                                <Grid.Row style={{ height: '500px', maxHeight: '500px', overflow: 'auto' }}>
                                    <Grid.Column>
                                        {baseProjects.length > 0
                                            ? this.renderTreeStructure()
                                            : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                                                <FontAwesomeIcon icon={faFolder} size='6x' />
                                                <p style={{ margin: '10px 0 0 0' }}>{i18n.t("Aucun projet/dossier trouvé.")}</p>
                                            </div>}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </Card.Content>
                </Card>
            </>
        );
    }

    componentDidMount = () => {
        ProjectsService.getOrganizationBaseProjects().then(baseProjects => this.setState({
            baseProjects: baseProjects || [],
            collapsedFolderIds: (baseProjects || []).filter(baseProject => baseProject.type === 'folder').map(baseProject => baseProject.id)
        }));
    }

    renderProjectsConsumptions = (uscToRender) => {
        const { activeOrganization } = this.props;
        const nbMaxTrees = activeOrganization.subscription.nbElements;
        const nbMaxGreenSpaces = activeOrganization.subscription.nbElements;
        const nbMaxFurnitures = activeOrganization.subscription.nbElements;

        return uscToRender.map(usc => {
            const { id, nbTrees, nbGreenSpaces, nbFurnitures } = usc;

            return (
                <Grid.Row key={id} stretched style={{ margin: '0 5px 5px 5px', paddingTop: '7px', paddingBottom: '7px' }}>
                    <Grid.Column computer={4} tablet={7} mobile={7}>
                        <Button
                            size='mini' as={Link} to={`/projects/${usc.project.id}`} target='_blank' title={i18n.t('Accéder au projet')}
                            className='op-project-button' style={{ textAlign: 'left', padding: '5px', borderRadius: 'var(--radius-xs)', display: 'flex', alignItems: 'center' }}
                        >
                            <span className='text-ellipsis' title={usc.project.label}>{usc.project.label}</span>
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ marginLeft: 'auto', fontSize: '8px', flexShrink: 0 }} />
                        </Button>
                    </Grid.Column>
                    <Grid.Column width={3} title={usc.user.email} className='org-col-hide-tablet' style={{ fontSize: '12px' }}>{FormattersUtil.formatLastNameAndFirstName(usc.user.lastName, usc.user.firstName)}</Grid.Column>
                    <Grid.Column width={3}>
                        <div>
                            {!isMobileOnly ?
                                <GaugeProgressBar
                                    label={nbTrees}
                                    values={[{
                                        value: nbTrees,
                                        maxValue: nbMaxTrees <= 0 ? nbTrees : nbMaxTrees,
                                        popupContent: (
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div>{i18n.t("Quantité")} : {nbTrees}{nbMaxTrees !== -1 && ` (${this.getFormattedValue(nbTrees, nbMaxTrees)}%)`}</div>
                                            </div>
                                        ),
                                        color: 'var(--primary-100)'
                                    }]}
                                /> : `${this.getFormattedValue(nbTrees, nbMaxTrees)}%`}
                        </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <div>
                            {!isMobileOnly ?
                                <GaugeProgressBar
                                    label={nbGreenSpaces}
                                    values={[{
                                        value: nbGreenSpaces,
                                        maxValue: nbMaxGreenSpaces <= 0 ? nbGreenSpaces : nbMaxGreenSpaces,
                                        popupContent: (
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div>{i18n.t("Quantité")} : {nbGreenSpaces}{nbMaxGreenSpaces !== -1 && ` (${this.getFormattedValue(nbGreenSpaces, nbMaxGreenSpaces)}%)`}</div>
                                            </div>
                                        ),
                                        color: 'var(--secondary-100)'
                                    }]}
                                /> : `${this.getFormattedValue(nbGreenSpaces, nbMaxGreenSpaces)}%`}
                        </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <div>
                            {!isMobileOnly ?
                                <GaugeProgressBar
                                    label={nbFurnitures}
                                    values={[{
                                        value: nbFurnitures,
                                        maxValue: nbMaxFurnitures <= 0 ? nbFurnitures : nbMaxFurnitures,
                                        popupContent: (
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div>{i18n.t("Quantité")} : {nbFurnitures}{nbMaxFurnitures !== -1 && ` (${this.getFormattedValue(nbFurnitures, nbMaxFurnitures)}%)`}</div>
                                            </div>
                                        ),
                                        color: 'var(--blue-100)'
                                    }]}
                                /> : `${this.getFormattedValue(nbFurnitures, nbMaxFurnitures)}%`}
                        </div>
                    </Grid.Column>
                </Grid.Row>
            )
        });
    }

    renderTreeStructure = () => {
        const { isDarkTheme } = this.props;
        const { isTransferring, selectedElements, baseProjects, treeSearchQuery } = this.state;
        let selectedColor = tinycolor(document.body.style.getPropertyValue('--primary-100'));
        selectedColor.setAlpha(isDarkTheme ? .2 : .4);

        const normalizedQuery = $(treeSearchQuery);
        let visibleIds = null;
        if (normalizedQuery) {
            visibleIds = new Set();
            baseProjects
                .filter(baseProject => $(baseProject.label)?.includes(normalizedQuery))
                .forEach(match => {
                    visibleIds.add(`${match.id}`);
                    match.path?.split('/').filter(Boolean).forEach(ancestorId => visibleIds.add(ancestorId));
                    baseProjects.filter(baseProject => baseProject.path?.includes(match.id)).forEach(descendant => visibleIds.add(`${descendant.id}`));
                });
        }

        const rootBaseProjects = baseProjects.filter(baseProject => !baseProject.path && (!visibleIds || visibleIds.has(`${baseProject.id}`)));

        if (normalizedQuery && rootBaseProjects.length === 0) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    <FontAwesomeIcon icon={faFolder} size='6x' />
                    <p style={{ margin: '10px 0 0 0' }}>{i18n.t("Aucun résultat.")}</p>
                </div>
            );
        }

        return (
            <div className={`org-tree ${isTransferring ? 'transferring' : ''}`} style={{ display: 'flex', flexDirection: 'column', width: '100%', userSelect: isTransferring ? 'none' : 'inherit' }}>
                {rootBaseProjects.map(baseProject => {
                    const isSelected = isTransferring && selectedElements.includes(baseProject.id);
                    return baseProject.type === 'project'
                        ? <div key={baseProject.id} className='org-tree-row' onClick={isTransferring ? this.selectElement(baseProject) : null} style={{ cursor: isTransferring ? 'pointer' : 'default', ...(isSelected ? { backgroundColor: selectedColor } : {}) }}>
                            <span className='org-tree-toggle-spacer' />
                            <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '7px', flexShrink: 0 }} />
                            <span className='org-tree-label' title={baseProject.label}>{baseProject.label}</span>
                        </div>
                        : this.renderFoldersStructure([baseProject], isSelected, 0, visibleIds)
                })}
            </div>
        )
    }

    renderFoldersStructure = (folders, isFolderSelected, level, visibleIds) => {
        const { isDarkTheme } = this.props;
        const { isTransferring, selectedElements, baseProjects, collapsedFolderIds } = this.state;
        let selectedColor = tinycolor(document.body.style.getPropertyValue('--primary-100'));
        selectedColor.setAlpha(isDarkTheme ? .2 : .4);

        return folders.map(folder => {
            const isFolder = folder.type === 'folder'
            const subFolders = baseProjects.filter(baseProject => baseProject.path && baseProject.path.endsWith(`/${folder.id}/`) && (!visibleIds || visibleIds.has(`${baseProject.id}`)));
            const hasChildren = isFolder && subFolders.length > 0;
            const isCollapsed = !visibleIds && collapsedFolderIds.includes(folder.id);
            const icon = isFolder ? (isCollapsed ? faFolder : faFolderOpen) : faFileAlt;
            const isSelected = isTransferring && (isFolderSelected || selectedElements.includes(folder.id));

            return (
                <div key={folder.id} className={level > 0 ? 'org-tree-branch--nested' : ''} style={{ marginLeft: level > 0 ? '36px' : 0 }}>
                    <div className={`org-tree-row ${hasChildren ? 'folder' : 'project'}`} onClick={isTransferring ? this.selectElement(folder) : (hasChildren ? this.toggleFolder(folder.id) : null)} style={{ cursor: isTransferring || hasChildren ? 'pointer' : 'default', ...(isSelected ? { backgroundColor: selectedColor } : {}) }}>
                        {hasChildren
                            ? <FontAwesomeIcon icon={isCollapsed ? faChevronRight : faChevronDown} className='org-tree-toggle' onClick={this.toggleFolder(folder.id)} />
                            : <span className='org-tree-toggle-spacer' />}
                        <FontAwesomeIcon icon={icon} style={{ marginRight: '7px', flexShrink: 0, color: isFolder && 'var(--yellow-100)' }} />
                        <span className='org-tree-label' title={folder.label}>{folder.label}</span>
                    </div>
                    {hasChildren && !isCollapsed && this.renderFoldersStructure(subFolders, isSelected, level + 1, visibleIds)}
                </div>
            );
        });
    }

    toggleFolder = (folderId) => (event) => {
        event.stopPropagation();
        this.setState(prevState => ({
            collapsedFolderIds: prevState.collapsedFolderIds.includes(folderId)
                ? prevState.collapsedFolderIds.filter(id => id !== folderId)
                : [...prevState.collapsedFolderIds, folderId]
        }));
    }

    getAllFolderIds = () => this.state.baseProjects.filter(baseProject => baseProject.type === 'folder').map(baseProject => baseProject.id);
    isAllFoldersExpanded = () => this.getAllFolderIds().every(folderId => !this.state.collapsedFolderIds.includes(folderId));
    expandAllFolders = () => this.setState({ collapsedFolderIds: [] });
    collapseAllFolders = () => this.setState({ collapsedFolderIds: this.getAllFolderIds() });

    getFormattedValue = (value, maxValue) => maxValue !== -1 ? (value / maxValue * 100) % 1 ? ((value / maxValue * 100).toFixed(2)) : (value / maxValue * 100) : 0;
    selectElement = (baseProject) => () => {
        let selectedElements = [...this.state.selectedElements];

        if (baseProject.path) {
            const parentFolderIds = this.state.baseProjects.filter(bp => baseProject.path.includes(bp.id)).map(bp => bp.id);
            if (selectedElements.find(se => parentFolderIds.includes(se))) return;
        }

        const subBaseProjectIds = this.state.baseProjects.filter(bp => bp.path?.includes(baseProject.id)).map(bp => bp.id);
        if (selectedElements.includes(baseProject.id)) selectedElements = selectedElements.filter(el => el !== baseProject.id && !subBaseProjectIds.includes(el));
        else selectedElements.push(baseProject.id);

        this.setState({ selectedElements });
    }

    transferElements = () => {
        const { userSubscriptionConsumptions, activeOrganization } = this.props;
        const { selectedOrganization, selectedElements, baseProjects } = this.state;

        this.setState({ isLoading: true });
        OrganizationsService.transferOrganizationData({ sourceOrganization: activeOrganization.id, targetOrganization: selectedOrganization, baseProjects: true, elementIds: selectedElements }).then((status) => {
            if (status === 200) {
                const filteredBaseProjects = baseProjects.filter(bp => !selectedElements.includes(bp.id) && (!bp.path || !selectedElements.find(se => bp.path.includes(se))));
                const filteredUSC = userSubscriptionConsumptions.filter(usc => filteredBaseProjects.find(fbp => fbp.id === usc.projectId))
                this.props.setUserSubscriptionConsumptions(filteredUSC);
                this.props.setProjects(null);
                this.setState({ isLoading: false, isTransferring: false, selectedOrganization: null, selectedElements: [], baseProjects: filteredBaseProjects });
            } else this.setState({ isLoading: false, isTransferring: false });
        });
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        activeOrganization: state.activeOrganization,
        organizations: state.organizations,
        loginAsData: state.loginAsData,
        isDarkTheme: state.isDarkTheme,
    };
}

const mapDispatchToProps = {
    setActiveOrganization,
    setProjects
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationProjects);